import type { Category_Schema } from "@/services/collection/categories/categoriesSchema";
import { CategoryId } from "@/services/collection/categories/categoriesSchema";
import type { z } from "zod";

export type Category = z.infer<typeof Category_Schema>;

export const TopCategoryIds = [CategoryId.SportsCards, CategoryId.Pokemon, CategoryId.LegoSets, CategoryId.LegoMinifigures];

export const HiddenDatabaseCategoryIds = [CategoryId.Watches, CategoryId.BoardGames, CategoryId.VinylRecords];
